/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationListenPodcastModel
 */
export interface FrontApplicationListenPodcastModel {
    /**
     * Podcast ID
     * @type {number}
     * @memberof FrontApplicationListenPodcastModel
     */
    programId: number;
    /**
     * Episode Uuid
     * @type {string}
     * @memberof FrontApplicationListenPodcastModel
     */
    episodeUuid: string;
    /**
     * Listen in seconds
     * @type {string}
     * @memberof FrontApplicationListenPodcastModel
     */
    listenedTimeInSeconds: string;
}

/**
 * Check if a given object implements the FrontApplicationListenPodcastModel interface.
 */
export function instanceOfFrontApplicationListenPodcastModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "programId" in value;
    isInstance = isInstance && "episodeUuid" in value;
    isInstance = isInstance && "listenedTimeInSeconds" in value;

    return isInstance;
}

export function FrontApplicationListenPodcastModelFromJSON(json: any): FrontApplicationListenPodcastModel {
    return FrontApplicationListenPodcastModelFromJSONTyped(json, false);
}

export function FrontApplicationListenPodcastModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationListenPodcastModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programId': json['programId'],
        'episodeUuid': json['episodeUuid'],
        'listenedTimeInSeconds': json['listenedTimeInSeconds'],
    };
}

export function FrontApplicationListenPodcastModelToJSON(value?: FrontApplicationListenPodcastModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programId': value.programId,
        'episodeUuid': value.episodeUuid,
        'listenedTimeInSeconds': value.listenedTimeInSeconds,
    };
}

